import React from 'react';
// @ts-expect-error ts-2307
import { CustomColorPicker } from 'highed';
import FieldContainer from './FieldContainer';
import { GenericInputProps } from 'shared/types/commonPropTypes';

const ColorWidget = (props: GenericInputProps) => {
  const value = (props.value || '') as string;
  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // eslint-disable-next-line no-new
    new CustomColorPicker(e.clientX, e.clientY, value, (color: string) => {
      if (props.isArraySelector) props.onChange({ val: color, index: props.index });
      else {
        props.onChange({ val: color });
      }
    });
  };
  return (
    <>
      {props.inputType === 'array<color>' || !props.label ? (
        <>
          <div className="relative group" id={props.option?.id}>
            <div className="color-picker-transparent-widget w-[30px] h-[30px] " />
            <div
              onClick={onClick}
              className="color-picker-widget w-[30px] h-[30px] border-4 border-solid border-white hover:border-ev-baby-blue-2 group-hover:border-ev-baby-blue-2 drop-shadow-color-widget-shadow"
              style={{
                backgroundColor: value
              }}
            />
          </div>
        </>
      ) : (
        <FieldContainer label={props.label} value={value} className={props.className} id={props.option?.id}>
          <div className="relative group ml-3">
            <div className="color-picker-transparent-widget h-6 w-6" />
            <div
              onClick={onClick}
              className="color-picker-widget w-6 h-6 border-4 border-solid border-white hover:border-ev-baby-blue-2 group-hover:border-ev-baby-blue-2 drop-shadow-color-widget-shadow"
              style={{
                backgroundColor: value
              }}
            />
          </div>
        </FieldContainer>
      )}
    </>
  );
};

export default ColorWidget;
